import Vue from 'vue'
import { Form, Input, Button, Row, Col, Checkbox, Select, DatePicker, Radio, Modal, Cascader } from 'ant-design-vue'
import Storage from 'vue-ls'
import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'
import UserIcon from '@/components/icon'
import MobileInput from '@/components/mobile-input'
import 'moment/locale/zh-cn'

import './css/index.less'

Vue.use(Storage)
Vue.use(Form)
Vue.use(Input)
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(Cascader)
Vue.use(SliderCaptcha)
Vue.use(VerificationCode)
Vue.use(UserIcon)
Vue.use(MobileInput)
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
